import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import Fields from './fields'
import validate from './validator'

const BookingPaymentForm = ({ onSubmit, handleSubmit, bookingDetails = {}, paymentOption, setPaymentOption, clientApplyCode, form, id }) => (
  <form onSubmit={handleSubmit(onSubmit)}>
    <Fields bookingDetails={bookingDetails}
      paymentOption={paymentOption} setPaymentOption={setPaymentOption} clientApplyCode={clientApplyCode} form={form}
      id={id}
    />
  </form>
)

BookingPaymentForm.propTypes = {
  bookingDetails: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  paymentOption: PropTypes.string.isRequired,
  setPaymentOption: PropTypes.func.isRequired,
  clientApplyCode: PropTypes.func,
  form: PropTypes.string,
  id: PropTypes.string
}

export default reduxForm({ enableReinitialize: true, validate })(BookingPaymentForm)
